import { useEffect, useState } from "react";
import { countryCodeMap } from "../utils/countryCodeMap";

const IPINFO_URL = "https://ipinfo.io/json?token=b45ae1fedc21cb";


export default function useCountryCode() {
  const [countryCode, setCountryCode] = useState("");
  const [permissionGranted, setPermissionGranted] = useState(null); // null = pending
  const [locationError, setLocationError] = useState("");

  useEffect(() => {
    let cancelled = false;

    const detectViaIp = () => {
      fetch(IPINFO_URL)
        .then((response) => {
          if (!response.ok) {
            throw new Error("Failed to fetch country code");
          }
          return response.json();
        })
        .then((data) => {
          if (cancelled) return;
          const dialCode = countryCodeMap[data.country] || "";
          setCountryCode(dialCode);
        })
        .catch((error) => {
          if (cancelled) return;
          setLocationError("Error fetching country code: " + error.message);
        });
    };

    const requestGeolocation = () => {
      const handleSuccess = () => {
        if (cancelled) return;
        setPermissionGranted(true);
        detectViaIp();
      };

      const handleError = (error) => {
        if (cancelled) return;
        setPermissionGranted(false);
        switch (error.code) {
          case error.PERMISSION_DENIED:
            setLocationError(
              "Location permission denied. Please select your country code.",
            );
            break;
          case error.POSITION_UNAVAILABLE:
            setLocationError(
              "Position unavailable. Please select your country code.",
            );
            break;
          case error.TIMEOUT:
            setLocationError(
              "Location request timed out. Please select your country code.",
            );
            break;
          default:
            setLocationError("Please select your country code.");
            break;
        }
      };

      navigator.geolocation.getCurrentPosition(handleSuccess, handleError);
    };

    const alreadyBlocked = () => {
      setPermissionGranted(false);
      setLocationError(
        "Location access is blocked for this site in your browser. " +
          "Please select your country code below, or allow location " +
          "access in your browser's site settings to auto-detect it.",
      );
    };

    if (!navigator.geolocation) {
      alreadyBlocked();
      return;
    }
    
    if (navigator.permissions && navigator.permissions.query) {
      navigator.permissions
        .query({ name: "geolocation" })
        .then((status) => {
          if (cancelled) return;

          if (status.state === "denied") {           
            alreadyBlocked();
            return;
          }
          
          requestGeolocation();
        })
        .catch(() => {
          
          if (!cancelled) requestGeolocation();
        });
    } else {
      requestGeolocation();
    }

    return () => {
      cancelled = true;
    };
  }, []);

  return { countryCode, setCountryCode, permissionGranted, locationError };
}